define("auth/controllers/profile-refresh-popup", ["exports", "@ember/controller", "@ember/object", "@ember/service", "tracked-built-ins", "later/services/errors", "later/services/mavely-auth", "shared/utils/is-popup-window"], function (_exports, _controller, _object, _service, _trackedBuiltIns, _errors, _mavelyAuth, _isPopupWindow) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.RefreshPopupErrors = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"tracked-built-ins",0,"later/services/errors",0,"later/services/mavely-auth",0,"shared/utils/is-popup-window"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  let RefreshPopupErrors = _exports.RefreshPopupErrors = /*#__PURE__*/function (RefreshPopupErrors) {
    RefreshPopupErrors["MismatchedProfile"] = "mismatched_profile";
    return RefreshPopupErrors;
  }({});
  let ProfileRefreshPopupController = _exports.default = (_class = class ProfileRefreshPopupController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "router", _descriptor3, this);
      _defineProperty(this, "queryParams", ['error']);
      _initializerDefineProperty(this, "error", _descriptor4, this);
      _initializerDefineProperty(this, "title", _descriptor5, this);
      _initializerDefineProperty(this, "body", _descriptor6, this);
    }
    onInsert() {
      const popupName = this.router.currentRoute.params.name;
      if (this.error === RefreshPopupErrors.MismatchedProfile) {
        this.title = this.intl.t('post.refresh_profile_popup.error.mismatched_profile.title');
        this.body = this.intl.t('post.refresh_profile_popup.error.mismatched_profile.body');
      } else if (popupName === _mavelyAuth.MAVELY_AUTH_POPUP_NAME) {
        this.title = this.intl.t('influencers.mavely.success_popup.title');
        this.body = this.intl.t('influencers.mavely.success_popup.body');
      } else {
        this.title = this.intl.t('post.refresh_profile_popup.success.title');
        this.body = this.intl.t('post.refresh_profile_popup.success.body');
      }
    }
    onClosePopup() {
      // Note: ensure only popup windows are closed
      if ((0, _isPopupWindow.default)()) {
        window.close();
      } else {
        this.errors.log('Attempting to close a non-popup window from `ProfileRefreshPopupController`', {}, _errors.ErrorSeverity.Warning);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "error", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "title", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "body", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClosePopup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClosePopup"), _class.prototype)), _class);
});